<template>
  <authCheck :pageUser="pageUser" :uid="uid" :pageBindFinished="pageBindFinished">

    <div class="pageUserIcon" v-if="!presentationMode && pageUser && pageUser.photoURL">
      <b-img :src="pageUser.photoURL" @click="showPageUser" :alt="`${this.pageUser.displayName}의 사진`" v-b-tooltip :title="`${this.pageUser.displayName}의 정보 보기`" class="cursor-pointer"/>
    </div>

    <h1 class="documentTitle" v-if="!presentationMode && pageUser" v-touch:touchhold="togglePresentationMode" v-touch:swipe="swipeApp">

      <b-button @click="showPageUser" v-b-tooltip :title="(isLoginUserPageUser)?'나의 정보 보기':`${this.pageUser.displayName}의 정보 보기`" variant="secondary" size="lg" class="fontSize1Dot4 p-0 pl-1 pr-1 mr-1 displayNoneMax589">
        {{(isLoginUserPageUser)? '나': pageUser.displayName}}</b-button><small class="fontSize1Dot4 displayNoneMax589">의</small>
      <router-link :to="{ name: 'tinkUser', params: { uid: this.uid, folder: '@root' }}" class="fontSize1Dot6 narrowText" custom v-slot="{ navigate }">
        <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
          기기 목록
        </span>  
      </router-link>

      <span v-if="folder == '@friend' && mode == 'list'" class="folderInTitle fontSize1Dot4 narrowText2" v-b-tooltip.hover title="나를 친구로 등록한 기기들">
        :&nbsp;
        @friend 폴더
      </span>
      <span v-else-if="folder == '@admin' && mode == 'list'" class="folderInTitle fontSize1Dot4 narrowText" v-b-tooltip.hover title="나를 관리자로 지정한 기기들">
        :&nbsp;
        @admin 폴더
      </span>
      <span v-else-if="folder != '@root' && mode == 'list'" class="folderInTitle fontSize1Dot4 narrowText">
        :&nbsp;
        {{ this.folder }} 폴더
      </span>

      <b-button :variant="(this.pageBinded)? 'primary' : 'secondary'" size="sm" class="ml-1 mr-1 fontSizeDot8 pt-dot1 pb-dot1 pr-2 pl-2 borderRadiusDot75 narrowText2" :disabled ="toggleRealtimeDisabled" @click="toggleRealtimeChanged" v-b-tooltip.hover title="내 기기들의 실시간 데이터 수신 여부에 대한 설정. 꺼짐이면 변경된 값을 받지 않습니다. 꺼짐이면 저장관련 버튼이 동작하지 않습니다.">
        실시간
        <span v-if="this.pageBinded">켜짐</span>
        <span v-else>꺼짐</span>
      </b-button>

    </h1>

    <div v-if="this.pageUser != null" class="m-3">
      <deviceAdd v-if="mode == 'add'" :pageBinded="pageBinded" :pageUser="pageUser" :uid="uid" :mode="mode"  :marker="marker" :action="action"/>
      <deviceMap v-else-if="mode=='map'" :pageBinded="pageBinded" :pageUser="pageUser" :uid="uid" :mode="mode" :marker="marker"/>
      <deviceList v-else :pageBinded="pageBinded" :pageUser="pageUser" :mode="mode" :uid="uid" :folder="folder" :marker="marker"/>
      <tPageUser :pageBinded="pageBinded" :pageUser="pageUser"/>
    </div>

  </authCheck>
</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

import { db } from "@/plugins/firebase.js"

import eventBus from "@/plugins/eventBus.js"

import uiUtil from "@/mixins/util.js"
import user from "@/mixins/user.js"

import deviceList from "@/components/user/deviceList.vue"
import deviceMap from "@/components/user/deviceMap.vue"
import deviceAdd from "@/components/user/deviceAdd.vue"
import tPageUser from "@/components/tPageUser.vue"

import authCheck from "@/components/authCheck.vue"

export default {
  name: 'user',
  mixins: [user, uiUtil],
  props: {
    did: {
      type: String,
      default: ""
    },
    folder: {
      type: String,
      default: "@root"
    },
    uid: {
      type: String,
      default: ""
    },
    action: {
      type: String,
      default: ""
    },
    mode: {
      type: String,
      default: "list"
    },
    marker: {
      type: String,
      default: ""
    },
  },
  components: {
    deviceList,
    deviceMap,
    deviceAdd,
    tPageUser,
    authCheck,
  },
  data : function() {
    return {
      pageUserBinded: null,
      pageBinded: false,
      pageBindFinished: false,
      bindTimer: null,
      toggleRealtimeDisabled: true,
    }
  },
  created() {
  },
  mounted() {
    firebase.auth().onAuthStateChanged((user) => {
      this.$log.debug("tinkUser.vue", "onAuthStateChanged");
      this.doBindPageUserOnce();
    })
  },
  updated() {
    this.$log.debug("tinkUser.vue", "updated pageUser", this.pageUser);
  },
  beforeDestroy() {
    this.$log.debug("tinkUser.vue", "beforeUnmount pageUser", this.pageUser);
  },
  methods: {
    swipeApp: function(direction) {
      this.$log.debug("swife", direction);
      if(direction == "left") {
        eventBus.$emit("busUiShow", "myMenuShow");
        eventBus.$emit("busShowPageUser", false);
      }
      else if(direction == "right") {
        eventBus.$emit("busUiHide", "myMenuShow");
        eventBus.$emit("busShowPageUser", true);
      }
    },
    toggleRealtimeChanged: function() {
      this.$log.debug("toggleRealtimeChanged")
      if(this.pageBinded) {
        if(!(this.loginUser && this.loginUserDeepBinding && this.loginUser.id == this.uid)) {
          this.$log.debug("unbind")
          this.unbindPageUser();
          this.toggleRealtimeDisabled = true;
          window.setTimeout(() => {
            this.toggleRealtimeDisabled = false;
          }, process.env.VUE_APP_CONTROL_DISABLED_TIMEOUT*1);
        }
      }
      else {
        this.bindPageUser();
      }
    },

    doBindPageUserOnce: function() {
      if(this.loginUserBinded) {
        this.bindPageUser();
      }
      else {
        if(!this.notLoginConfirmed) {
          window.setTimeout(()=> {
            this.doBindPageUserOnce();
          },1000);
        }
      }
    },

    bindPageUser: function() {

      if(this.loginUser && this.loginUserDeepBinding && this.loginUser.id == this.uid) {
        window.setTimeout(()=> {
          this.pageBinded = true;
          this.pageBindFinished = true;
          this.toggleRealtimeDisabled = true;
        }, 1000);
      }
      else {
        this.$bind("pageUserBinded", db.collection("users").doc(this.uid), {
          maxRefDepth: 2,
          reset: false
        })
        .then(() => {

          window.setTimeout(()=> {
            this.pageBinded = true;
            this.pageBindFinished = true;
            this.toggleRealtimeDisabled = true;
          }, 1000);

          window.setTimeout(() => {
            this.toggleRealtimeDisabled = false;
          }, process.env.VUE_APP_CONTROL_DISABLED_TIMEOUT*1);

          window.setTimeout(() => {
            this.toggleRealtimeChanged();
          }, process.env.VUE_APP_PAGE_TIMEOUT*1);

        })
        .catch((error) => {
          console.log(error);

          this.pageBinded = false;
          this.pageBindFinished = true;
          this.toggleRealtimeDisabled = true;
        })
      }
    },

    unbindPageUser: function() {
      if(this.pageBinded) {
        if(this.pageUserBinded != null) {
          this.$unbind("pageUserBinded", false);
          this.pageBinded = false;
        }
      }
    },
  },

  computed: {

    pageUser: function() {
      if(!this.pageBindFinished) {
        return null;
      }
      else if(this.pageUserBinded != null) {
        return this.pageUserBinded;
      }
      else if(this.loginUser && this.loginUser.id == this.uid) {
        return this.loginUser;
      }
      return null;
    }
  },

  watch: {
    uid: function() {
      if(this.bindTimer != null) {
        window.clearTimeout(this.bindTimer);
      }

      this.pageUserBinded = null;
      this.pageBinded = false;
      this.pageBindFinished = false;
      this.bindTimer = null;
      this.toggleRealtimeDisabled = true;

      window.setTimeout(() => {
        this.doBindPageUserOnce();
      }, 100);
    },
  },
}
</script>
